var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6495 5.65437C12.6492 5.65408 12.6489 5.65378 12.6486 5.65348L7.34564 0.350708C7.11961 0.124573 6.81908 0 6.49942 0C6.17976 0 5.87923 0.124474 5.6531 0.350609L0.352903 5.6507C0.351118 5.65249 0.349333 5.65437 0.347548 5.65616C-0.116625 6.12301 -0.115831 6.88046 0.349829 7.34612C0.562574 7.55897 0.843557 7.68225 1.14398 7.69514C1.15618 7.69633 1.16848 7.69693 1.18088 7.69693H1.39223V11.5994C1.39223 12.3717 2.02055 13 2.79298 13H4.86767C5.07794 13 5.24853 12.8295 5.24853 12.6191V9.55957C5.24853 9.20718 5.53517 8.92054 5.88756 8.92054H7.11127C7.46367 8.92054 7.7503 9.20718 7.7503 9.55957V12.6191C7.7503 12.8295 7.9208 13 8.13116 13H10.2059C10.9783 13 11.6066 12.3717 11.6066 11.5994V7.69693H11.8026C12.1222 7.69693 12.4227 7.57246 12.6489 7.34632C13.1151 6.87987 13.1153 6.12112 12.6495 5.65437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.1af66a5089569c89274ebbcefe85f7bb.svg";
export { ForwardRef as ReactComponent };